import api from "../../utils/apiUserTienda";

export const getCategorias = async () => {
  const res = await api.get("/api/tienda/categorias/obtener");
  return res.data.data || [];
};

export const createCategoria = async (data) => {
  const isFormData = data instanceof FormData;

  const res = await api.post("/api/tienda/categorias/crear", data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });

  return res.data;
};

export const updateCategoria = async (id, data) => {
  const isFormData = data instanceof FormData;

  const res = await api.put(`/api/tienda/categorias/actualizar/${id}`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });

  return res.data;
};

export const obtenerCategoriasActivas = async () => {
  const res = await api.get("/api/tienda/categorias/obtener/activas");
  return res.data.data || [];
};